(function($, duo, undefined) {

  "use strict";

  // classes:
  const GENERAL_MODAL_OPEN_CLASS = 'js-modalisopen';

  /**
   * @class Modal
   */
  class Modal {

    /**
     * Creates an instance of Modal
     * @param {string} modalSelector css selector for the modal
     * @param {string} toggleButtonClass css class name for modal toggle buttons
     * @param {string} openClass css class name used on the classHolder when the modal is open
     * @param {string} classHolder css selector for the element that will contain the toggle class
     * @param {bool} useTransitions set to "true" if the modal uses transitions to open and close the modal
     * @param {bool} fixPagePositionWhenOpen set to "true" to save scroll position when opening the modal
     * @param {string} fixPageClass css class name used on the classHolder when the modal is fixed
     * @param {object} elementToChangeScrollOnFixed element to set the scroll position on when the modal is fixed
     * @param {object} elementToFocusOnClose element to focus on close, if no sender-element is available
     * @param {bool} allowClickOnBackgroundToClose if set to true, clicking on the background element will close the modal
     * @param {function} functionToExecuteOnOpen function to execute when the modal is opened
     * @param {function} functionToExecuteOnClose function to execute when the modal is closed
     */
    constructor({modalSelector = '.modal', toggleButtonClass = 'js-toggle-modal', openClass = 'js-modal-visible', classHolder = 'html', useTransitions = true, fixPagePositionWhenOpen = true, fixPageClass = 'js-modal-fixed', elementToChangeScrollOnFixed, elementToFocusOnClose, allowClickOnBackgroundToClose = true, functionToExecuteOnOpen, functionToExecuteOnClose} = {}) {
      this.modalSelector = modalSelector;
      this.element = $(modalSelector);

      this.toggleButtonClass = toggleButtonClass;
      this.openClass = openClass;
      this.classHolder = $(classHolder);
      this.useTransitions = useTransitions;
      this.fixPagePositionWhenOpen = fixPagePositionWhenOpen;
      this.fixPageClass = fixPageClass;
      this.elementToChangeScrollOnFixed = elementToChangeScrollOnFixed;
      this.elementToFocusOnClose = elementToFocusOnClose;
      this.allowClickOnBackgroundToClose = allowClickOnBackgroundToClose;
      this.functionToExecuteOnOpen = functionToExecuteOnOpen;
      this.functionToExecuteOnClose = functionToExecuteOnClose;


      this.currentTogglerElement = null;
      this.scrollPosition = 0;

      // focus helper:
      this.keyboardTrap = new duo.KeyboardTrap(modalSelector);

      // setup html:
      if(this.allowClickOnBackgroundToClose) {
        this.element.addClass('js-bgclick-enabled');
      }

      // setup event handlers:
      this._setEventHandlers();
    } /* constructor */

    /**
     * Getter - returns Modal visibility
     * @returns {bool} a boolean to indicate whether the Modal is visible
     */
    get isVisible() {
      return this.classHolder.hasClass(this.openClass);
    } /* isVisible */

    /**
     * Show the Modal
     */
    show($senderButton) {
      const modal = this;

      // save the sender-button:
      modal.currentTogglerElement = $senderButton;

      // check if user has scrolled before opening the modal:
      if($('body').hasClass('js-scroll-active')) {
        modal.classHolder.addClass('js-modal--user-had-scrolled');
      }

      // save the scroll position:
      if(modal.fixPagePositionWhenOpen) {
        modal.scrollPosition = $(window).scrollTop();
      }

      // add the openClass:
      modal.classHolder.addClass(modal.openClass);
      $('html').addClass(GENERAL_MODAL_OPEN_CLASS);

      // fixed page class:
      if(modal.fixPagePositionWhenOpen) {
        modal.classHolder.addClass(modal.fixPageClass);
        modal.elementToChangeScrollOnFixed.css('top', '-' + modal.scrollPosition + 'px');
      }

      // do stuff if the modal is not using transitions
      // (if the modal does use transitions, we do these things
      //  after the transitionend-event);
      if(!modal.useTransitions) {
        // -> change aria-hidden on the modal-element:
        modal.element.attr('aria-hidden', 'false');
        // -> enable keyboard-trap:
        modal.keyboardTrap.reInit();
        modal.keyboardTrap.trap();
        // -> "hide" page content:
        $('.page-wrapper').attr('aria-hidden', 'true');
        // -> execute "open"-function:
        if(modal.functionToExecuteOnOpen !== undefined) {
          modal.functionToExecuteOnOpen();
        }
      }

      // page focus listener:
      // -> attach a listener to redirect the tab to the modal window if the user gets out of the modal window:
      $('body').on('focusin.modal', '.page-wrapper', function() {
        modal.keyboardTrap.trap();
      });
    } /* show */

    /**
     * Hide the Modal
     */
    hide() {
      // remove the openClass:
      this.classHolder.removeClass(this.openClass);
      $('html').removeClass(GENERAL_MODAL_OPEN_CLASS);

      // remove "user had scrolled" class:
      this.classHolder.removeClass('js-modal--user-had-scrolled');

      // remove fixed page class:
      $('html').removeClass(this.fixPageClass);

      // reset the scroll position:
      if(this.fixPagePositionWhenOpen) {
        $(window).scrollTop(this.scrollPosition);
        this.elementToChangeScrollOnFixed.css('top', '');
      }

      // change aria-hidden on the modal-element:
      this.element.attr('aria-hidden', 'true');

      // "show" page content:
      $('.page-wrapper').attr('aria-hidden', 'false');

      // remove page focus listener:
      $('body').off('focusin.modal', '.page-wrapper');

      // stop keyboard-trap:
      this.keyboardTrap.unTrap();
      if(this.elementToFocusOnClose !== undefined) {
        this.elementToFocusOnClose.focus();
      } else {
        if(this.currentTogglerElement !== null) {
          this.currentTogglerElement.focus();
        }
      }

      // execute "on close" function:
      if(this.functionToExecuteOnClose !== undefined) {
        this.functionToExecuteOnClose();
      }
    } /* hide */

    /**
     * Toggle the Modal
     */
    toggle($senderButton) {
      if(this.isVisible) {
        this.hide();
      } else {
        this.show($senderButton);
      }
    } /* toggle */

    /**
     * Set event handlers
     */
    _setEventHandlers() {
      const modal = this;

      // toggle-button:
      $(document).on('click', `.${modal.toggleButtonClass}`, function(event) {
        event.preventDefault();
        modal.toggle($(this));
      });

      // close buttons in modal:
      modal.element.on('click', '.js-modal-close', function(event) {
        event.preventDefault();
        modal.hide();
      });

      // close the modal with the keyboard (ESC-key):
      $(document).on('keydown.modal', function(event) {
        if(event.keyCode === 27) {
          if(modal.isVisible) {
            modal.hide();
          }
        }
      });

      // close the modal by clicking on the background:
      if(modal.allowClickOnBackgroundToClose) {
        $(document).on('click', '[data-modal-element="background"]', function(event) {
          event.preventDefault();
          if(modal.isVisible) {
            modal.hide();
          }
        });
      }

      // transition-end event:
      // -> note: this event fires for every property that transitions
      if(modal.useTransitions) {
        modal.element.on(duo.Utils.transitionEvent, function(event) {
          if(event.originalEvent.propertyName === 'visibility') {
            if(event.target === modal.element[0]) {
              if(modal.isVisible) {
                // --> change aria-hidden on the modal-element:
                modal.element.attr('aria-hidden', 'false');
                // --> keyboard trap:
                if(!modal.keyboardTrap.isActive) {
                  modal.keyboardTrap.reInit();
                  modal.keyboardTrap.trap();
                }
                // --> aria-hidden on page:
                $('.page-wrapper').attr('aria-hidden', 'true');
                // -> execute "open"-function:
                if(modal.functionToExecuteOnOpen !== undefined) {
                  modal.functionToExecuteOnOpen();
                }
              }
            }
          }
        });
      }
    } /* _setEventHandlers */
  
  } /* Modal */

  duo.Modal = Modal;

})(jQuery, window.duo = window.duo || {});
